import { render, staticRenderFns } from "./clientCard.vue?vue&type=template&id=1d25dab2&scoped=true"
import script from "./clientCard.vue?vue&type=script&lang=js"
export * from "./clientCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d25dab2",
  null
  
)

export default component.exports